export default class ConstraintResource {
    constructor(resource = {data: {}, meta: {new: true}, relations: {}}, name = null) {
        this.data = resource.data;
        this.meta = resource.meta;
        this.relations = resource.relations;
        this.name = name;

        if(Array.isArray(this.relations) && (this.relations.length < 1)) {
            this.relations = {};
        }

        this.initialize();
    }

    initialize() {
        this.__casts();
    }

    __casts() {
        Object.keys(this.casts).forEach((key) => {
            if(this.data[key] !== null && typeof this.data[key] !== 'undefined') {
                this.data[key] = new this.casts[key](this.data[key]);

                // if(this.data[key] instanceof Boolean) {
                //     this.data[key] = this.data[key].valueOf();
                // }
            }
        });
    }

    get model() {
        return this.name ?? this.constructor.name.substring(0, this.constructor.name.length - 8); // Where -8 is "Resource"
    }

    get key() {
        return this.data.id;
    }
};

/**
 * Storing it in the prototype due javascript is simply too dumb to handle inheritance properly.
 *
 * For a better solution, please pick up the contact with your local representatives and ask them to ban
 * javascript from the face of the earth. So then we can have a proper alternative in the future, probably.
 */
ConstraintResource.prototype.casts = {
    created_at: Date,
    updated_at: Date,
    deleted_at: Date,
};
